import { useArticleUnpublishMutation } from 'lib-knowledge-management-common/graphql';
import { ampli } from 'lib-shared-tracking';

type MutationFunction = ReturnType<typeof useArticleUnpublishMutation>[0];
type MutationReturnValue = ReturnType<MutationFunction>;

export type UnPublishFn = () => MutationReturnValue;

type UseArticleUnpublishReturnValue = [
  UnPublishFn,
  ReturnType<typeof useArticleUnpublishMutation>[1],
];

type UseArticleUnpublishParams = {
  articleId: string;
};

function useArticleUnpublish({
  articleId,
}: UseArticleUnpublishParams): UseArticleUnpublishReturnValue {
  const [unPublish, mutationResult] = useArticleUnpublishMutation();
  const updateFn: UnPublishFn = () => {
    return unPublish({
      variables: {
        articleId,
      },
      refetchQueries: ['ArticleTranslation'],
    }).then((args) => {
      ampli.knowledgeArticleUnpublished({ articleId });
      return args;
    });
  };

  return [updateFn, mutationResult];
}

export default useArticleUnpublish;
